interface UseDemandHistoryProps {
  historico: any[];
}

export const useDemandHistory = ({ historico }: UseDemandHistoryProps) => {
  // Função para verificar se um anexo foi enviado com comentário
  const hasAttachmentComment = (anexoId: number): boolean => {
    return historico.some(item => {
      if (item.type === 'attachment_added' && item.details?.comment) {
        try {
          const data = JSON.parse(item.details.comment);
          if (data.anexos && Array.isArray(data.anexos)) {
            const attachmentWithComment = data.anexos.find((anexo: any) => anexo.id === anexoId);
            if (attachmentWithComment) {
              // Verificar se tem comentário geral, individual ou ambos
              const hasGeneralComment = (data.comentario || data.comentario_geral) && (data.comentario || data.comentario_geral).trim();
              const hasIndividualComment = attachmentWithComment.comentario_individual && attachmentWithComment.comentario_individual.trim();
              return hasGeneralComment || hasIndividualComment;
            }
          }
        } catch  {
          // Ignorar erros de parsing
        }
      }
      return false;
    });
  };

  // Função para obter o comentário específico de um anexo
  const getAttachmentComment = (anexoId: number): string => {
    for (const item of historico) {
      if (item.type === 'attachment_added' && item.details?.comment) {
        try {
          const data = JSON.parse(item.details.comment);
          if (data.anexos && Array.isArray(data.anexos)) {
            const attachmentWithComment = data.anexos.find((anexo: any) => anexo.id === anexoId);
            if (attachmentWithComment) {
              // Priorizar comentário individual, depois comentário geral
              const individualComment = attachmentWithComment.comentario_individual;
              const generalComment = data.comentario || data.comentario_geral;
              
              if (individualComment && individualComment.trim()) {
                return individualComment.trim();
              } else if (generalComment && generalComment.trim()) {
                return generalComment.trim();
              }
            }
          }
        } catch {
          // Ignorar erros de parsing
        }
      }
    }
    return '';
  };

  return {
    hasAttachmentComment,
    getAttachmentComment
  };
};